const API_BASE = process.env.REACT_APP_API_URL || '';

export async function getComplianceSummary(orgId, programId) {
  const params = new URLSearchParams();
  if (programId) params.append('programId', programId);
  
  const queryString = params.toString();
  const url = `${API_BASE}/orgs/${orgId}/compliance/summary${queryString ? '?' + queryString : ''}`;
  
  const response = await fetch(url, {
    credentials: 'include',
    headers: {
      'x-org-id': orgId
    }
  });
  
  if (!response.ok) {
    if (response.status === 403) {
      throw new Error('You do not have permission to view compliance summary');
    }
    throw new Error('Failed to fetch compliance summary');
  }
  
  const data = await response.json();
  return data.summary;
}
